import { Pairs } from "#/types/markets";
import { type OpenOrder, type OpenOrdersByPairs } from "#/types/orders";

export const getDefaultOpenOrders = (): OpenOrdersByPairs => {
  return Object.fromEntries(
    Object.values(Pairs).map((pair) => [pair, [] as OpenOrder[]]),
  ) as OpenOrdersByPairs;
};
